import { useEffect, ReactNode } from "react";
import "./toastUi.scss";

import toast, { IToastOption } from "@src/utils/toast";
import { logEvent } from "@src/reactGa";

import { Icon } from "@src/shared/src";

export default function ToastUi(
  props: IToastOption & {
    id?: number | string;
    message: string | ReactNode;
  },
) {
  const {
    id,
    message,
    icon,
    emoji,
    position,
    textAlign,
    bottomPosition,
    removeTime,
    isAutoRemove,
    onClick,
  } = props;

  const xPosition = position?.[0];
  const yPosition = position?.[1];

  const inlineStyle = {};
  if (textAlign) {
    inlineStyle["text-align"] = textAlign;
  }
  if (bottomPosition) {
    inlineStyle["bottom"] = bottomPosition;
  }

  // 자동삭제
  // id 필수, isAutoRemove는 true가 기본값, removeTime은 5000ms가 기본값
  useEffect(() => {
    if (id === undefined || isAutoRemove === false) return;

    const _removeTime = removeTime || 5000;
    const timeout = setTimeout(() => toast.removeToast(id), _removeTime);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, [id, isAutoRemove]);

  function handleClickToast() {
    if (onClick === undefined) return;

    // GA 처리
    logEvent("notice", {
      component: "toast",
      behavior: "click",
      title: message,
      page_path: window.location.pathname,
    });

    onClick();
  }

  return (
    <div
      className={`
        toast-ui-component-container
        ${position ? "fade-in-animation" : "slide-up-animation"}
        ${xPosition ? `toast-ui-x-position-${xPosition}` : ""}
        ${yPosition ? `toast-ui-y-position-${yPosition}` : ""}
      `}
      style={inlineStyle}
    >
      <div className="toast-ui-component" onClick={handleClickToast}>
        {icon && (
          <div className="toast-ui-component-icon">
            <Icon name={icon.name} size={icon.size || 18} />
          </div>
        )}
        {emoji && <span className="toast-ui-component-emoji">{emoji}</span>}
        {typeof message === "string" ? <p className="toast-ui-component-message">{message}</p> : message}
      </div>
    </div>
  );
}
